function logDebug (message) {
  if (window.gaLogDebug) {
    console.log('GoogleAnalytics :', ...arguments)
  }
}

export default class GaPlugin {
  trackView (name, path) {
    window.gtag('config', window.gaTrackingId, {
      'page_title': name,
      'page_path': path
    })
    logDebug('trackView:', {
      'page_title': name,
      'page_path': path
    })
  }

  trackEvent (category = null, action = null, label = null, value = null) {
    window.gtag('event', action, {
      'event_category': category,
      'event_label': label,
      'value': value
    })
    logDebug('trackEvent:', {
      'event_action': action,
      'event_category': category,
      'event_label': label,
      'value': value
    })
  }

  trackScreen (screen) {
    window.gtag('event', 'screen_view', {
      'app_name': window.appName,
      'screen_name': screen
    })
    logDebug('trackScreen:', {
      'screen_name': screen
    })
  }

  setUserId (userId) {
    window.gtag('set', {'user_id': userId}) // 使用已登录的 user_id 来设置用户 ID。
    logDebug('setUserId:', {
      'user_id': userId
    })
  }
}
